<template>
	<div class="d-flex align-items-center">
		<UiElement
			tag="button"
			:settings="settings"
			:style="{ opacity: isRemoveDisabled || (amount || count) === 0 ? 0 : 1, pointerEvents: isRemoveDisabled || (amount || count) === 0 ? 'none' : 'auto' }"
			disable-hover
			@touchstart="removeCount"
			style="padding-bottom:2%"
		>
			-
		</UiElement>

		<div class="d-flex align-items-center justify-content-center">
			<slot v-bind="{ count: amount || count }" />
		</div>

		<UiElement
			tag="button"
			:settings="settings"
			:style="{ opacity: isAddDisabled ? 0.2 : 1, pointerEvents: isAddDisabled ? 'none' : 'auto' }"
			disable-hover
			@touchstart="addCount"
			style="padding-top:1%"
		>
			+
		</UiElement>
	</div>
</template>

<script setup>
	import { computed, defineProps } from 'vue';
	import { useOrderStore } from '@/stores/useOrderStore';
	import { useDialogStore } from '@/stores/useDialogStore';
	import UiElement from '@/components/UI/UiElement.vue';
	import { storeToRefs } from 'pinia';

	const MAX_COUNT = 99;

	const orderStore = useOrderStore();

	const { addProduct, removeProduct, getAmount } = useOrderStore();
	const { showDialogMaxCount } = useDialogStore();
	const { cart } = storeToRefs(orderStore);

	const props = defineProps({
		settings: {
			type: Object,
			required: true
		},
		product: {
			type: Object,
			required: true
		},
		amount: {
			type: Number,
			required: false
		},
		isAddDisabled: {
			type: Boolean,
			default: false
		},
		isRemoveDisabled: {
			type: Boolean,
			default: false
		}
	});

	const count = computed(() => {
		if (!props.product?.id) return 0;

		const orderIndex = buildProductOrderIndex(props.product);

		return getAmount(orderIndex);
	});

	function addCount() {
		if (props.isAddDisabled) return;

		if (!props.product?.id) return;

		if (cart.value.length === MAX_COUNT || count.value === MAX_COUNT) {
			showDialogMaxCount();
			return;
		}

		addProduct(props.product, [
			...(props.product.modifiers || []),
			...(props.product.notes || [])
		]);
	}

	function removeCount() {
		if (props.isRemoveDisabled) return;

		if (!props.product?.id) return;
		if (count.value === 0) return;

		removeProduct(props.product, [
			...(props.product.modifiers || []),
			...(props.product.notes || [])
		]);
	}

	function buildProductOrderIndex(product) {
		const allModifiers = [
			...(product.modifiers || []),
			...(product.notes || [])
		];
		const sorted = [...allModifiers].sort((a, b) => a.id - b.id);
		const modifiersIds = sorted.map(m => m.id).join('_');

		return `${product.id}_${modifiersIds}`;
	}
</script>